import {Outlet} from "react-router-dom";

const Appointments = () => {

  return <Outlet/>
}

export default Appointments;